import QuicklyGenerateCertificateModal from './quickly-generate-certificate-modal.vue'
export default QuicklyGenerateCertificateModal
